var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companies"},[_c('SectionHeader',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('BreadCrumbs',{attrs:{"items":[
          { text: _vm.$t('containerGroups.containerGroups'), name: 'company_container_groups' },
          {
            text: _vm.containerGroup.name,
            name: 'company_container_group',
            params: { container_group_uuid: _vm.$route.params.container_group_uuid },
          },
          { text: _vm.$t('containers.addEmptyingTemplate') } ]}})]},proxy:true}])}),_c('div',{staticClass:"body-content cf"},[_c('CompanyNav'),_c('div',{staticClass:"body"},[_c('EmptyingTemplateNewForm',{attrs:{"afterSubmit":_vm.onSubmit}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }